<div class="flex flex-col gap-4">
	<div class="flex lg:hidden">
		<vp-filter-button
			[indicator]="indicator()"
			[label]="'compositions.filters.title' | translate"
			[openable]="true"
			data-test-id="filters-button"
			iconLeading="assets/icons/icon-filter.svg"
		>
			<ng-content />
		</vp-filter-button>
	</div>
	<div class="flex flex-row justify-between">
		<span class="h4" data-test-id="filter-header-title">{{ title() }}</span>
		<vp-dropdown
			[alignment]="dropdownAlignment()"
			[selectData]="sortOptions()"
			[value]="'global.sort-by' | translate"
			(selectedValue)="onSortChange($event)"
			data-test-id="sort-options-dropdown"
			downIcon="icon-sort"
			placeholder="global.sort-by"
			upIcon="icon-sort"
			variant="detached"
		/>
	</div>
</div>
